import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { MapPinOffIcon } from 'lucide-react';
import { useEffect } from 'react';
import { FieldMap } from '@/components/map';
import { EmptyState, ListSkeleton } from '@/components/states';
import { Button } from '@/components/ui/button';
import { integer } from '@/lib/format';
import { useGeolocation } from '@/lib/use-geolocation';
import { mapPoints } from '@/offline/queries';
import { useOfflineQuery } from '@/offline/use-offline-query';

export const Route = createFileRoute('/_app/peta')({
  component: MapPage,
});

/** Peta sebaran nasabah (T-P7-16, FR-NAV-05). */
function MapPage() {
  const navigate = useNavigate();
  const { reading, locate, status } = useGeolocation();
  const { data, loading } = useOfflineQuery(() => mapPoints(), []);

  useEffect(() => {
    if (status === 'idle') locate();
  }, [status, locate]);

  if (loading) return <ListSkeleton rows={3} />;

  if (!data || data.points.length === 0) {
    return (
      <EmptyState
        icon={MapPinOffIcon}
        title="Belum ada nasabah berkoordinat"
        description="Koordinat terisi setelah check-in kunjungan pertama atau setelah data alamat dilengkapi back office."
      />
    );
  }

  return (
    <div className="space-y-3 px-4 py-4">
      <FieldMap
        height={420}
        cluster
        showMe={reading?.position ?? null}
        markers={data.points.map((point) => ({
          id: point.loanId,
          lat: point.lat,
          lng: point.lng,
          title: point.customerName,
          subtitle: point.loanNumber,
          collectibility: point.collectibility,
          onSelect: () =>
            void navigate({ to: '/nasabah/$loanId', params: { loanId: point.loanId } }),
        }))}
      />

      <p className="text-xs text-muted-foreground">
        Menampilkan {integer(data.points.length)} nasabah dengan tunggakan terlama.
        {data.hiddenCount > 0 ? ` ${integer(data.hiddenCount)} lainnya disembunyikan.` : ''}
        {data.withoutCoordinates > 0
          ? ` ${integer(data.withoutCoordinates)} nasabah belum berkoordinat.`
          : ''}
      </p>

      <Button variant="secondary" fullWidth onClick={() => locate()}>
        Perbarui posisi saya
      </Button>
    </div>
  );
}
